import styled from 'styled-components'

export const LoadingWrapper = styled.div`
  position: absolute !important;
  width: 100vw !important;
  height: 100vh !important;
`
